import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import * as catalogActions from "../../actions/catalogs";
import Layout from "../../components/layout";
import PaymentLinesReport from "../../components/paymentLinesReport";
import { showDocument } from "../../actions/documents";
import * as reportes from "../../actions/reports";

interface Props {
  getClubs: () => void;
  toggleBill: (storageId: number) => any;
  downloadReportPaymentLines: (
    clubId: string,
    fechaInicio: string,
    fechaFin: string,
    membresiaIdPublico: string,
    idPersona: string,
    referencia: string
  ) => any;
  clubs: object[];
}

interface State {}

class PaymentLinesPage extends React.Component<Props, State> {
  state = {};

  componentDidMount() {
    this.props.getClubs();
  }

  render() {
    return (
      <main>
        <Helmet title="Payment Lines Report" />
        <Layout>
          <PaymentLinesReport
            clubs={this.props.clubs}
            toggleBill={this.props.toggleBill}
            downloadReportPaymentLines={this.props.downloadReportPaymentLines}
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ catalogs }) => {
  return {
    clubs: catalogs.clubs
  };
};

const mapDispatchToProps = dispatch => ({
  toggleBill: showDocument,
  getClubs: () => {
    dispatch(catalogActions.getClubs());
  },
  downloadReportPaymentLines: (
    clubId: string,
    fechaInicio: string,
    fechaFin: string,
    membresiaIdPublico: string,
    idPersona: string,
    referencia: string
  ) => {
    dispatch(
      reportes.downloadReportPaymentLines(
        clubId,
        fechaInicio,
        fechaFin,
        membresiaIdPublico,
        idPersona,
        referencia
      )
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentLinesPage);
